export const SENTIENCE_INPUT = 'SENTIENCE_INPUT' as const;
export const SENTIENCE_OUTPUT = 'SENTIENCE_OUTPUT' as const;
